<template>
  <div v-if="isOpen">
    <div class="modal is-active">
      <div class="modal-background"></div>

      <div class="animation-content" style="max-width: 1800px">
        <div class="modal-card full-height">
          <header class="modal-card-head">
            <div class="modal-card-header">
              <slot name="header"></slot>
            </div>
            <button type="button" class="delete" aria-label="close" @click="close"></button>
          </header>

          <section class="modal-card-body">
            <app-loading-section :loading="isLoading">
              <div v-if="isMobile" class="modal_page--single">
                <slot name="single"></slot>
              </div>

              <div v-else class="flex">
                <div class="modal_page--left">
                  <slot name="left"></slot>
                </div>
                <div class="modal_page--middle">
                  <slot name="middle"></slot>
                </div>
                <div class="modal_page--right">
                  <slot name="right"></slot>
                </div>
              </div>
            </app-loading-section>
          </section>

          <footer v-if="$slots.footer" class="modal-card-foot">
            <slot name="footer"></slot>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalPage",
  props: {
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isOpen: false,
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    }
  },
  methods: {
    open() {
      this.isOpen = true;
      this.$emit('open');
    },
    close() {
      this.isOpen = false;
      this.$emit('close');
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.modal-card-header {
  flex-grow: 1;
}

.modal-card-body {
  padding: 0;
}

.modal_page {

  &--single {
    padding: $modalGutter;
  }

  &--left {
    width: 25%;
    min-width: 320px + ($modalGutter * 2);
    padding: $modalGutter;
  }

  &--middle {
    flex-grow: 1;
    padding: $modalGutter 0;
  }

  &--right {
    width: 33%;
    min-width: 420px + ($modalGutter * 2);
    padding: $modalGutter;
  }
}
</style>
